import { ERegion } from '@timeedit/types/lib/enums/region.enum';

export const REGION_PLACEHOLDER = '|_REGION_|';

const regionSubdomain: Record<ERegion, string> = {
  [ERegion.EU_EES]: 'eu',
  [ERegion.ANZ]: 'anz',
  [ERegion.SGP]: 'sgp',
  [ERegion.UK]: 'uk',
};

export const regionifyUrl = (url: string, region: ERegion) =>
  url.replace(REGION_PLACEHOLDER, regionSubdomain[region]);
